import React from 'react';

import { ButtonPrimaryTextOnly, Flex, styled } from '@creditas-ui/react';
import { useEjnActions } from '../../../hook/useEjnActions';

const StyledFlex = styled(Flex)`
  border-bottom: 1px solid rgba(237, 240, 239, 1);
  align-items: center;
  justify-content: space-between;
  padding: 32px;
`;

const ActionButton = styled(ButtonPrimaryTextOnly)`
  width: 47%
`;

const EjnActionsComponent: React.FC = () => {
  const { showSendNotificationModal, showProtestModal } = useEjnActions();

  return (
    <StyledFlex>
      <ActionButton onClick={showProtestModal} size="medium" width="flexible">
        Enviar para Protesto
      </ActionButton>
      <ActionButton
        onClick={showSendNotificationModal}
        size="medium"
        width="flexible"
      >
        Renotificar
      </ActionButton>
    </StyledFlex>
  );
};

const EjnActions = React.memo(EjnActionsComponent);

export default EjnActions;
